

import Chart from 'chart.js';


export function setChartsBackgroundColor(color: string) {

    Chart.plugins.register({
        beforeDraw: function (chart: any) {
            const ctx = chart.chart.ctx;
            ctx.restore();
            ctx.fillStyle = color;
            ctx.fillRect(0, 0, chart.chart.width, chart.chart.height);
            ctx.save();
        }
    });
}


export const zeroCompensation2 = {
    renderZeroCompensation: function (chartInstance: any, d: any) {
        // get postion info from _view
        const view = d._view
        const context = chartInstance.chart.ctx

        // the view.x is the centeral point of the bar, so we need minus half width of the bar.
        const startX = view.x - view.width / 2
        // common canvas API, Check it out on MDN
        context.beginPath();
        // set line color, you can do more custom settings here.
        context.strokeStyle = 'gray';
        context.moveTo(startX, view.y);
        // draw the line!
        context.lineTo(startX + view.width, view.y);
        // bam！ you will see the lines.
        context.stroke();
    },

    afterDatasetsDraw: function (chart: any, easing: any) {
        // get data meta, we need the location info in _view property.
        const meta = chart.getDatasetMeta(0)
        // also you need get datasets to find which item is 0.
        const dataSet = chart.config.data.datasets[0].data
        meta.data.forEach((d: any, index: number) => {
            // for the item which value is 0, reander a line.
            if(dataSet[index] === 0) {
                this.renderZeroCompensation(chart, d)
            }
        })
    }
};

const minBarHeight = 2;
const minBarWidth = 20;

export const zeroCompensation = {
    id: 'zeroCompensation',

    beforeDatasetsDraw: function(chart: any) {
        const meta = chart.getDatasetMeta(0)
        meta.data.forEach( (d:any) => {
            const barHeight = d._view.base - d._view.y;
            if(Math.abs(barHeight) < minBarHeight) {
                d._view.y = d._view.base - minBarHeight * (Math.sign(barHeight) || 1);
            }
        });
    }};


// function foo(chart: any) {
//
//     const meta = chart.getDatasetMeta(0)
//     console.log(meta)
//     meta.data.forEach( (d:any) => {
//         const barWidth = d._view.x - d._view.base;
//         if(Math.abs(barWidth) < minBarWidth) {
//             d._view.x = d._view.base - minBarWidth * (Math.sign(barWidth) || 1);
//             console.log(d._view.x )
//         }
//     });
// }
//
// export const zeroCompensationHorizontal = {
//     id: 'zeroCompensation',
//     beforeDatasetsDraw: foo, beforeDraw: foo, afterDraw: foo, afterDatasetsDraw: foo
// };
